import Vue from "vue";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import { version } from "../../package.json";

if (process.env.VUE_APP_ENVIRONMENT !== "local") {
  const dsnEnv =
    process.env.VUE_APP_ENVIRONMENT === "production"
      ? "https://bd559d2b0759f5fbfe64212c843ce0f1@sentry.housfy.com/45"
      : "https://0538660a3c5510d56aff3975c2975164@sentry.housfy.com/44";

  Sentry.init({
    Vue,
    dsn: dsnEnv,
    maxBreadcrumbs: 50,
    release: `hibo-agency-${version}`,
    environment: process.env.VUE_APP_ENVIRONMENT,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}
